import DSSAlgorithmInputs from "../../../../../templates/views/DSS/DSSAlgorithmInputs";
import store from 'dashboard/store';

export default {
  path: 'algorithm-inputs',
  name: 'DSSAlgorithmInputs',
  component: DSSAlgorithmInputs,
  meta: {
    title: 'MDSS - Algorithm Inputs',
    loggedInOnly: true,
    inSDMSessionOnly: true,
  },
  async beforeEnter(to, from, next) {
    if (store.getters['isTestingEnvironment']){
      next();
    }else{
      next({
        name: 'DSSCardioMedication',
        params: { patientId: to.params.patientId },
      });
    }
  },
};
